import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "unlockedFilled"
const UnlockedFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M17.625 1.5C18.918 1.5 20.158 2.013 21.073 2.927 21.987 3.842 22.5 5.082 22.5 6.375H21C21 5.48 20.644 4.622 20.011 3.989S18.521 3 17.625 3C16.73 3 15.872 3.356 15.239 3.989S14.25 5.479 14.25 6.375V9.532C15.964 9.964 16.5 10.5 16.5 10.5V21Q16.5 21.15 16.47 21.294L16.459 21.342Q16.449 21.389 16.435 21.434 16.427 21.46 16.417 21.486 16.403 21.528 16.387 21.569 16.377 21.594 16.365 21.617L16.328 21.696Q16.312 21.725 16.295 21.754L16.258 21.814Q16.24 21.842 16.222 21.867 16.198 21.9 16.173 21.932L16.136 21.977 16.08 22.04 16.042 22.077Q16.011 22.107 15.978 22.134L15.933 22.173Q15.903 22.196 15.872 22.218L15.82 22.255 15.756 22.294Q15.726 22.31 15.697 22.327 15.666 22.343 15.633 22.357 15.6 22.375 15.568 22.388L15.508 22.41 15.435 22.435Q15.383 22.45 15.33 22.462L15.3 22.469Q15.228 22.484 15.153 22.492T15 22.5H3C2.172 22.5 1.5 21.828 1.5 21V10.5S3 9 9 9C10.524 9 11.758 9.097 12.75 9.241V6H12.766C12.856 4.844 13.352 3.753 14.178 2.927 15.092 2.013 16.331 1.5 17.625 1.5M9 14.625C8.172 14.625 7.5 15.297 7.5 16.125S8.172 17.625 9 17.625 10.5 16.953 10.5 16.125 9.828 14.625 9 14.625"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default UnlockedFilledIcon
